<template>

  <div class="grid-content bg-purple">


    <div class="grid-content bg-purple">
      <h2 style="float: left;">现场考核记录</h2>
      <div class="point">

        <el-col :span="4" style="padding: 0; margin:10px 20px ;width:auto; ">
          <el-date-picker
            v-model="ayears"
            type="year"
            format="yyyy"
            value-format="yyyy"
            @change="pickerChangeFn"
            :picker-options="pickerOptions"
            placeholder="请选择年份">
          </el-date-picker>
        </el-col>
        <el-col :span="4" style="padding: 0;margin:10px 0px ; margin-right: 20px;width:auto; ">

          <!--                  <h2 style="float: left;">第</h2>-->

          <!--                  <el-input v-model="aquarter" type="text" placeholder="请输入季度"></el-input>-->
          <el-select v-model="aquarter" placeholder="请选择季度" style=" ;padding: 0px 0px 0px;width: 120px" :clearable ="true">

            <el-option
              v-for="item in quarters"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <!-- <h2 style="float: left;">季度</h2>&ndash;&gt;-->
        </el-col>
        <el-col :span="4 " style="padding: 0; margin-right: 10px; width:auto; ">
          <el-button type="info" style="width: 139px; height: auto; color: #fff ; text-align: center; margin-top:0px!important" @click="setabt(1)">查询</el-button>
        </el-col>
      </div>
      <el-button type="primary" @click="dialogCheckRecordslest=true">增加考核记录</el-button>
      <div class="table-box" style="margin-top: 60px">

        <el-table
          :data="tCheckRecord"
          height="550"
          border
          style="width: 100%;">
          <el-table-column
            type="index"
            label="序号"
            width="80"
          >
          </el-table-column>
          <el-table-column
            label="年份季度"
          >
            <template slot-scope="scope">
              {{scope.row.year}}年第({{scope.row.quarter}})季
            </template>
          </el-table-column>
          <el-table-column
            prop="assessArea"
            label="地区/地点"
          >
          </el-table-column>
          <el-table-column
            prop="scoreItemName"
            label="考核项"
          >
          </el-table-column>
          <el-table-column
            label="现场照"
          >
            <template slot-scope="scope">
              <img v-image-preview :src="scope.row.img"  alt=""
                                              style="
                                                height: 64px;
                                                cursor:pointer;

                                               "/>
            </template>
          </el-table-column>

          <el-table-column

            label="操作">
            <template slot-scope="scope">
              <el-button
              	type="success"
                size="mini"
                @click="opentCheckRecord(scope.row.recordId)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="openDelete(scope.row.recordId)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <el-pagination
      	v-if="tCheckRecordtotal>10"
        background
        layout="prev, pager, next"
        :page-size="tCheckRecordpageSize"
        :total="tCheckRecordtotal"
        :current-page.sync="currentPage"
        @current-change="settCheckRecords"
      >
      </el-pagination>
    </div>



    <el-dialog class="table-box"  :visible.sync="dialogCheckRecordslest"  :before-close="dialogroleRecordslestclose">

    <el-form ref="form" label-width="200px">

      <el-form-item label="*季度：" style="text-align: left;">
        <el-col :span="9" style="width: 200px">
          <el-date-picker
            v-model="createCheckRecord.year"
            type="year"
            style="width: 100%"
            format="yyyy"
            value-format="yyyy"
            :picker-options="pickerOptionsadd"
            @change="pickerChangeFn"
            placeholder="请选择年份">
          </el-date-picker>
        </el-col>
        <el-col class="line" :span="2" style="line-height: 40px;text-align: center;">-</el-col>
        <el-col :span="9">
          <el-select v-model="createCheckRecord.quarter" placeholder="请选择季度" style="float: left ;padding: 0px 0px 0px;width: 160px;" :clearable ="true" >

            <el-option
              v-for="item in quarters"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>


        </el-col>
      </el-form-item >

      <el-form-item label="*现场考核标题：">
        <el-input v-model="createCheckRecord.title" type="text" placeholder="请输入现场考核标题"></el-input>
      </el-form-item>
      <el-form-item label="*指标项：">
        <el-select v-model="createCheckRecord.scoreItemId" placeholder="请选择" style="float: left;">
          <el-option
            v-for="item in ScoreItemAll"
            :key="item.scoreItemId"
            :label="item.scoreItem"
            :value="item.scoreItemId">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="*现场照：">
        <el-upload
          class="avatar-uploader"
          :action="afileUrl"
          name="files"
          :show-file-list="false"
          :on-success="handleimgSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="fileimg" :src="fileimg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>

      </el-form-item>

      <el-form-item label="*考核地点：">
        <el-input v-model="createCheckRecord.assessArea" type="text" placeholder="请输入考核地点"></el-input>
      </el-form-item>
      <el-form-item label="*拍摄人：">
        <el-input v-model="createCheckRecord.photographedPeople" type="text" placeholder="请输拍摄人"></el-input>
      </el-form-item>
      <el-form-item label="*拍摄日期：">
        <el-date-picker type="date" placeholder="拍摄时间"  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd HH:mm:ss" v-model="createCheckRecord.photographedTime" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="createCheckRecordAdd()">确认提交</el-button>

      </el-form-item>
    </el-form>

    </el-dialog>



    <el-dialog class="table-box" style="background: none;  " :modal="true" :visible.sync="dialogCheckRecordsVisible" :before-close="dialogroleRecordslestclose">

        <el-form ref="form"  label-width="200px">

          <el-form-item label="季度：">
            <el-col :span="9">
              <el-date-picker
                v-model="updateRecords.year"
                type="year"
                style="width: 100%"
                format="yyyy"
                value-format="yyyy"
                :picker-options="pickerOptionsEnd"
                @change="pickerChangeFn"
                placeholder="请选择年份">
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2" style="line-height: 40px;text-align: center;">-</el-col>
            <el-col :span="9">
              <el-select v-model="updateRecords.quarter" placeholder="请选择季度" style="float: left ;padding: 0px 0px 0px;" :clearable ="true">

                <el-option
                  v-for="item in quarters"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>


            </el-col>
          </el-form-item >
          <el-form-item label="现场考核标题：">
            <el-input v-model="updateRecords.title" type="text" placeholder="请输入现场考核标题"></el-input>
          </el-form-item>
          <el-form-item label="指标项：">
            <el-select v-model="updateRecords.socreItemId" placeholder="请选择" style="float: left;">
              <el-option
                v-for="item in ScoreItemAll"
                :key="item.scoreItemId"
                :label="item.scoreItem"
                :value="item.scoreItemId">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="现场照1：">
            <el-upload
              class="avatar-uploader"
              :action="afileUrl"
              name="files"
              :show-file-list="false"
              :on-success="handleimgSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="fileimg" :src="fileimg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

          </el-form-item>

          <el-form-item label="考核地点：">
            <el-input v-model="updateRecords.assessArea" type="text" placeholder="请输入考核地点"></el-input>
          </el-form-item>
          <el-form-item label="拍摄人：">
            <el-input v-model="updateRecords.photographedPeople" type="text" placeholder="请输拍摄人"></el-input>
          </el-form-item>
          <el-form-item label="拍摄日期：">
            <el-date-picker type="date" placeholder="拍摄时间"  format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd HH:mm:ss" v-model="updateRecords.photographedTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="updateCheckRecord">确认提交</el-button>

          </el-form-item>
        </el-form>

    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "Inspection",
  data(){
    return {
      tCheckRecord: [],
      tCheckRecordtotal:0,
      currentPage:1,
      tCheckRecordpageSize:10,
      pickerOptionsadd: {
        disabledDate: time => {
          let beginDateVal = this.createCheckRecord.year
          // if (beginDateVal) {
          return (
            time.getTime() <
            new Date(beginDateVal).getTime() - 86400000 || time.getTime() > Date.now()
          )
          // }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.updateRecords.year
          // if (beginDateVal) {
          return (
            time.getTime() <
            new Date(beginDateVal).getTime() - 86400000 || time.getTime() > Date.now()
          )
          // }
        }
      },

      //现场考核
      createCheckRecord:{
        year:'',
        quarter:'',
        title:'',
        scoreItemId:'',
        img:'',
        assessArea:'',
        photographedPeople: '',
        photographedTime: '',


      },
      dialogCheckRecordslest:false,
      dialogCheckRecordsVisible:false,
      ScoreItemAll:{},

      updateRecords:{
        year:'',
        quarter:'',
        title:'',
        assessArea:'',
        socreItemId:'',
        img:'',
        photographedPeople:'',
        photographedTime:''
      },


      afileUrl:'/api/upload/imgs',

      fileimg:'',
      aquarter:'',
      ayears:'',
      aquarte:'',
      ayear:'',
      quarters: [
        {   id:1,
          name: '第一季度',

        },
        {   id:2,
          name: '第二季度',

        },
        {
          id:3,
          name: '第三季度',
        },
        {
          id:4,
          name: '第四季度',
        },
      ],
      pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.tCheckRecords();
    this.selectScoreItemAll();
  },
  methods: {
    pickerChangeFn(value){ // 日期选择器改变事件 ~ 解决日期选择器清空 值不清空的问题
      if(value===null){
        this.ayears = value

      }},
    setabt(page){
      if(this.ayears == '' || this.ayears == null){
        this.$message.error('请选择年份！！！');
        return false;
      }
      if(this.aquarter == '' || this.aquarter == null){
        this.$message.error('请选择季度！！！');
        return false;
      }
      this.currentPage = 1;
      this.tCheckRecords(page);
    },

    dialogroleRecordslestclose(){
      this.fileimg=''
      this.dialogCheckRecordsVisible = false;
      this.createCheckRecord = {
        year:'',
        quarter:'',
        title:'',
        scoreItemId:'',
        img:'',
        assessArea:'',
        photographedPeople: '',
        photographedTime: '',


      };
      this.dialogCheckRecordslest = false;
      this.updateRecords={
        year:'',
        quarter:'',
        title:'',
        assessArea:'',
        socreItemId:'',
        img:'',
        photographedPeople:'',
        photographedTime:''
      };
    },
    //通用上传
    handleimgSuccess(res, file) {
      var that = this;

      if(res.data.errno==0){
        that.fileimg = res.data.data[0];
      }else{
        that.$message.error('上传失败');
      }
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、JPEG、PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    //所有指标项
    selectScoreItemAll(){
      let that = this;
      this.$axios
        .get('/api/scoreItem/selectScoreItemAll')
        .then(function (res) {
          if(res.data.code == 200){
            that.ScoreItemAll = res.data.data;
            // console.log(that.AllOperator);

          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    //现场考核记录
    tCheckRecords(page){
      let that = this;
      let myDate = new Date();
      let years = myDate.getFullYear(); //获取当前年
      let mon = myDate.getMonth() + 1; //获取当前月
      let aquarters = 1
      if(mon>=1&&mon<4){
        aquarters = 1;
      }else if(mon>=4&&mon<7){
        aquarters = 2;
      }else if(mon>=7&&mon<10){
        aquarters = 3;
      }else if(mon>=10&&mon<12){
        aquarters = 4;
      }
      this.ayear =that.ayears||''+years;
      this.aquarte = that.aquarter;

      let Checdata = {
        page:page?page:that.currentPage,
        pageSize:that.tCheckRecordpageSize,
        year:this.ayear,
        quarter:this.aquarte,
      }
      console.log(Checdata)
      this.$axios
        .post('/api/checkRecord/selectCheckRecord',Checdata)
        .then(function (res) {

          if(res.data.code==200){
            that.tCheckRecord = res.data.data.list;
            that.tCheckRecordtotal = res.data.data.total;

          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    settCheckRecords(currentPage){
      this.currentPage = currentPage;
      this.tCheckRecords();
    },



    createCheckRecordAdd(){
      let that = this;
      if (that.createCheckRecord.year == '' || that.createCheckRecord.year == null) {
        that.$message.error('请选择年份');
        return false;
      }
      if (that.createCheckRecord.quarter == '') {
        that.$message.error('请选择季度');
        return false;
      }
      if (that.createCheckRecord.title == '') {
        that.$message.error('请输入现场考核标题');
        return false;
      }
      if (that.createCheckRecord.scoreItemId == '') {
        that.$message.error('请选择指标项');
        return false;
      }
      that.createCheckRecord.img = that.fileimg;
      if (that.createCheckRecord.img == '') {
        that.$message.error('请上传现场照');
        return false;
      }
      if (that.createCheckRecord.assessArea == '') {
        that.$message.error('请输入考核地点');
        return false;
      }
      if (that.createCheckRecord.photographedPeople == '') {
        that.$message.error('请输入拍摄人');
        return false;
      }
      if (!that.createCheckRecord.photographedTime) {
      	console.log('111')
        that.$message.error('请选择拍摄日期');
        return false;
      }
      let createCheckRecorddata = {
        year:that.createCheckRecord.year,
        quarter:that.createCheckRecord.quarter,
        title: that.createCheckRecord.title,
        scoreItemId: that.createCheckRecord.scoreItemId,
        img: that.createCheckRecord.img,
        assessArea: that.createCheckRecord.assessArea,
        photographedPeople: that.createCheckRecord.photographedPeople,
        photographedTime: that.createCheckRecord.photographedTime,
      }
      this.$axios
        .post('/api/checkRecord/createCheckRecord', createCheckRecorddata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("新增现场考核失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '新增现场考核成功',
              type: 'success'
            });

            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);

          }


        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },

    selectCheckRecordById(){
      let that = this;


      let checkRecorddata = {
        id:that.CheckRecorid,
      }
      this.$axios
        .post('/api/checkRecord/selectCheckRecordById', checkRecorddata)
        .then(function (res) {
          that.updateRecords.year=''+res.data.data.year;
          that.updateRecords.quarter=res.data.data.quarter;
          that.updateRecords.title= res.data.data.title;
          that.updateRecords.assessArea= res.data.data.assessArea;
          that.updateRecords.socreItemId= res.data.data.socreItemId;
          that.updateRecords.img= res.data.data.img;
          that.fileimg =that.updateRecords.img;
          that.updateRecords.photographedPeople= res.data.data.photographedPeople;
          that.updateRecords.photographedTime= res.data.data.photographedTime;

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


    opentCheckRecord(CheckRecorid){

      this.CheckRecorid = CheckRecorid;

      this.selectCheckRecordById();
      this.selectScoreItemAll();
      window.setTimeout(() => {
        this.dialogCheckRecordsVisible = true;
      },100);
    },

    //修改角色
    updateCheckRecord(){
      let that = this;
      if (that.updateRecords.year == '' || that.updateRecords.year == null) {
        that.$message.error('请选择年份');
        return false;
      }
      if (that.updateRecords.quarter == '') {
        that.$message.error('请选择季度');
        return false;
      }
      if (that.updateRecords.title == '') {
        that.$message.error('请输入现场考核标题');
        return false;
      }
      if (that.updateRecords.scoreItemId == '') {
        that.$message.error('请选择指标项');
        return false;
      }
      that.updateRecords.img = that.fileimg;
      if (that.updateRecords.img == '') {
        that.$message.error('请上传现场照');
        return false;
      }
      if (that.updateRecords.assessArea == '') {
        that.$message.error('请输入考核地点');
        return false;
      }
      if (that.updateRecords.photographedPeople == '') {
        that.$message.error('请输入拍摄人');
        return false;
      }
      if (!that.updateRecords.photographedTime) {
        that.$message.error('请选择拍摄日期');
        return false;
      }
      that.updateRecords.img =that.fileimg;
      let updateRecorddata = {
        id:that.CheckRecorid,
        year:that.updateRecords.year,
        quarter:that.updateRecords.quarter,
        title:that.updateRecords.title,
        assessArea:that.updateRecords.assessArea,
        socreItemId:that.updateRecords.socreItemId,
        img:that.updateRecords.img,
        photographedPeople:that.updateRecords.photographedPeople,
        photographedTime:that.updateRecords.photographedTime
      }
      this.$axios
        .post('/api/checkRecord/updateRecord', updateRecorddata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("修改失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '修改成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    openDelete(RecordIds) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DeleteCheckRecord(RecordIds)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //删除考核项分类
    DeleteCheckRecord(RecordIds){
      let that = this;
      let RecordIdsdeta = {
        id:RecordIds
      }
      // RecordIdsdeta.id.push(RecordIds);
      this.$axios
        .post('/api/checkRecord/deleteRecord',RecordIdsdeta)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

  },
  watch: {

  },
}
</script>

<style scoped>

/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: left;
}
/deep/ .el-upload:hover {
  border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
/deep/ .avatar {
  width: 60px;
  height: 60px;
  display: block;
}
/deep/ .el-table--border::after, .el-table--group::after, .el-table::before{
  z-index: -1;
}

.point{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: 0px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
/deep/ .el-button--info{
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/Inspection.vue